import * as React from 'react';

export const LazyRiskLevelNOKExclusion = React.lazy(() => import('./component'));
